import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CheckPassword, CreateChancel, PasswordInput } from 'components';
import { FindLoad, FindErrorItem, useModal, PasswordValidator, ErrorText, FindSuccess, isNotEmpty, makeCapitalize } from 'utils';
import { clientActions, httpRequestsOnErrorsActions, httpRequestsOnSuccessActions } from 'store';
import { checkPassword } from '../../../login/core/constants';

const ACTION_TYPE = 'SET_CLIENT_CONTACT_PASSWORD';

export const SetContactPassword = ({ info }) => {
    const client = useSelector((state) => state.client.clientItemInfo);
    const { close } = useModal();
    const dispatch = useDispatch();
    const [error, setError] = useState('');
    const [inputs, setInputs] = useState({
        newPassword: '',
        confirmation: '',
    });
    const successType = FindSuccess(ACTION_TYPE);
    const loader = FindLoad(ACTION_TYPE);
    const beckError = FindErrorItem(ACTION_TYPE);
    const contactName = `${makeCapitalize(info?.firstName)} ${info?.lastName ? makeCapitalize(info?.lastName) : ''}`.trim();

    useEffect(() => {
        dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
    }, []);

    useEffect(() => {
        if (!!successType.length) {
            close();
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
        }
    }, [successType]);

    const handleChange = (e) => {
        setInputs((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
        (error === e.target.name && setError(''), error === 'confirmationNotEqual' && setError(''));
        if (beckError?.error) {
            dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
        }
    };

    const handleChangePassword = () => {
        const changePassDataIsValid = isNotEmpty(inputs?.newPassword) && isNotEmpty(inputs?.confirmation);

        if (changePassDataIsValid && !error) {
            const data = {
                newPassword: inputs.newPassword,
                confirmation: inputs.confirmation,
            };
            if (inputs?.newPassword === inputs?.confirmation) {
                dispatch(clientActions.setClientContactPassword(info?.id, data, client?.id));
            } else {
                setError('confirmationNotEqual');
            }
        } else {
            if (!isNotEmpty(inputs.newPassword)) {
                setError('newPassword');
            } else if (!isNotEmpty(inputs.confirmation)) {
                setError('confirmation');
            }
        }
    };

    const handleCheck = (bool, name) => {
        if (bool === true) {
            setError(name);
        } else {
            setError('');
        }
    };

    return (
        <div style={{ width: 400 }}>
            <p className="modal-header-title">Set Password</p>
            <p className="modal-header-sub">
                You are manually setting a Client Portal password for <b>{contactName}</b>. Share these credentials directly with the
                parent/client.
            </p>
            <div className="modal-body-wrapper">
                <PasswordInput
                    validator={PasswordValidator}
                    sendBoolean={(bool) => handleCheck(bool, 'newPasswordNotValid')}
                    handleChangePassword={handleChange}
                    type={'password'}
                    name={'newPassword'}
                    disabled={false}
                    variant={'accountPassword'}
                    value={inputs.newPassword}
                    onChange={handleChange}
                    typeError={
                        error === 'newPasswordNotValid' ? ErrorText.passwordValid : error === 'newPassword' && 'New password is required.'
                    }
                    placeholder={'New Password*'}
                />
                <PasswordInput
                    validator={PasswordValidator}
                    sendBoolean={(bool) => handleCheck(bool, 'confirmationNotValid')}
                    handleChangePassword={handleChange}
                    type={'password'}
                    name={'confirmation'}
                    disabled={false}
                    variant={'accountPassword'}
                    value={inputs.confirmation}
                    onChange={handleChange}
                    typeError={
                        error === 'confirmationNotEqual'
                            ? 'Passwords do not match.'
                            : error === 'confirmationNotValid'
                              ? ErrorText.passwordValid
                              : error === 'confirmation' && 'Password confirmation is required.'
                    }
                    placeholder={'Retype New Password*'}
                />
                <CheckPassword fields={checkPassword} text={inputs.newPassword} isActive={inputs.newPassword} />
                {beckError?.error && <p style={{ color: '#D92D20', fontSize: 14, marginTop: 8 }}>{beckError.error}</p>}
            </div>
            <CreateChancel
                onCreate={handleChangePassword}
                type="button"
                loader={!!loader.length}
                create={'Save'}
                chancel={'Cancel'}
                onClose={close}
                buttonWidth="428px"
            />
        </div>
    );
};
